import { Button, Col, Progress, Row } from 'antd';
import { useEffect, useState } from 'react';

import styles from './billing-details.module.scss';
import Icon from 'utils/icon';
import ChargeModalComponent from '../chargeModel/chargeModel.component';

function ProfileBillingDetailsComponent() {
	const [showChargeModal, setShowChargeModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const onConfirm = () => {
		setIsLoading(true);
		setTimeout(() => {
			setShowChargeModal(false);
			setIsLoading(false);
		}, 1000);
	};

	const onDiscard = () => {
		setShowChargeModal(false);
	};

	return (
		<>
			<div className="sectionContainer">
				<div className={styles.attention}>
					<Icon name="attention" width={40} height={40} />
					<div>
						<h6>We need your attention!</h6>
						<p>
							Your payment was declined. To start using tools. <Button type="link">please Add Payment Method</Button>
						</p>
					</div>
				</div>

				<Row gutter={[20, 20]}>
					<Col md={12} sm={24}>
						<h6>Active until Dec 09, 2024</h6>
						<p>We will send you a notification upon Subscription expiration</p>
					</Col>

					<Col md={12} sm={24}>
						<div className="d-flex justify-content-between">
							<h6>Active until Dec 09, 2024</h6>
							<h6>86 of 100 Used</h6>
						</div>

						<Progress percent={80} showInfo={false} />

						<p>14 Users remaining until your plan requires update</p>
					</Col>

					<Col md={12} sm={24}>
						<h6>
							S.R 4,500.00 <span>Current wallet</span>
						</h6>
					</Col>

					<Col md={12} sm={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Button type="primary" onClick={() => setShowChargeModal(true)}>
							Charge wallet
						</Button>
					</Col>
				</Row>
			</div>

			<ChargeModalComponent onConfirm={onConfirm} onDiscard={onDiscard} open={showChargeModal} isLoading={isLoading} />
		</>
	);
}

export default ProfileBillingDetailsComponent;
